export const categories = (state) => state.categories.filter(category => category.parent_id == null)

export const subCategories = (state) => id => {
    return state.categories.filter(category => category.parent_id == id)
}
